( function ( _s ) {
	/**
	 * Hides/shows the pinned element(s) based on the filters.
	 * If at least one visible filter has a value and the value is either not empty or not the default one
	 * then we hide the pinned element(s), else we show it.
	 *
	 * @param {*} _elements
	 * @param {*} _filters
	 * @returns
	 */
	const toggleVisibilityOnFiltersApplied = ( _elements, _filters ) => {
		//bail early
		if ( ! _elements.length ) return;

		//vars
		const visibleFilters = [];
		const filtersValues = [];

		//get all the fields that aren't hidden or disabled
		_filters.find( `select, textarea, input[type]` ).each( iEl => {
			if ( ! iEl.disabled && iEl.getAttribute( 'type' ) !== 'hidden' ) {
				//save the name of the inputs that are visible
				visibleFilters.push( iEl.getAttribute( 'name' ) );
			}
		} );

		//get the current filter configuration
		_filters.trigger( 'fr:get-filters-config', {
			callback: data => {
				for ( const [ key, value ] of Object.entries( data ) ) {
					if ( visibleFilters.includes( key ) ) {
						switch ( key ) {
							//NEED TO HANDLE P_TYPE
							case 'order_by':
								filtersValues.push( value.length && value !== 'upcoming_first' );
								break;
							default:
								filtersValues.push( value.length !== 0 );
								break;
						}
					}
				}

				//if at least one filter has value and is not the default value
				_elements.each( iEl => {
					_s( iEl ).toggleClass(
						'd-none',
						filtersValues.some( el => el === true )
					);
				} );
			},
		} );
	};

	const updateUrlParams = ( _filters, params ) => {
		const visibleFilters = [];
		//get all the fields that aren't hidden or disabled
		_filters.find( `select, textarea, input[type]` ).each( iEl => {
			if ( ! iEl.disabled && iEl.getAttribute( 'type' ) !== 'hidden' ) {
				//save the name of the inputs that are visible
				visibleFilters.push( iEl.getAttribute( 'name' ) );
			}
		} );

		const cleanedConfig = Object.fromEntries(
			Object.entries( params ).filter( ( [ _, v ] ) => {
				return v.length > 0 && visibleFilters.includes( _ );
			} )
		);

		_s( window ).trigger( 'fr:update-url-params', {
			urlParams: new URLSearchParams( cleanedConfig ).toString(),
		} );
	};

	_s.fn.cardGridWithFilters = function () {
		return this.each( el => {
			const _self = _s( el );
			const _filters = _self.find( '.card-grid-filters' );
			const _toggleVisibilityElements = _self.find( '[fr-hide-on-non-empty-filters]' );
			const _cardContainers = _self.find( '.cards-container' );

			//on page load set the filter configuration on the _cardContainers
			_filters.trigger( 'fr:get-filters-config', {
				callback: data => {
					_cardContainers.trigger( 'fr:set-ajax-config', { config: data } );
				},
			} );

			//on filters changed let's do the ajax and toggle visibility of pinned elements
			_filters.on(
				'fr:filters-changed',
				window.debounce( e => {
					//update url params
					updateUrlParams( _filters, e.detail.params );
					//show or hide pinned card
					toggleVisibilityOnFiltersApplied( _toggleVisibilityElements, _filters );
					//trigger ajax
					_cardContainers.trigger( 'fr:do-ajax', { config: e.detail.params } );
				}, 100 )
			);

			_cardContainers.on( 'fr:ajax-started', () => {
				//Nothing to do right now here but it might be helpful.
				//For example add a class to the _filters so that all inputs are disabled while the ajax runs
				_filters.addClass( 'disabled-inputs' );
			} );

			_cardContainers.on( 'fr:ajax-ended', () => {
				_filters.removeClass( 'disabled-inputs' );
			} );

			_cardContainers.on( 'fr:cards-added', () => {
				//call the text clamping functionality on cards
				_s( window ).trigger( 'fr:initialize-shave', {
					callback: () => {
						_s( '.card' ).cardInit();
					},
				} );
			} );
		} );
	};

	_s( document ).ready( () => {
		_s( '.card-grid-with-filters-module' ).cardGridWithFilters();
	} );
} )( window._s );
